import { createContext, useContext, useEffect, useState } from "react";
import { apiLogin } from "@services/api";
import { getUser, setUser, getIsAuth, setIsAuth, clearAuth } from "@utils/storage";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,            setUserState]    = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading,         setLoading]      = useState(true);

  // Restore session on mount
  useEffect(() => {
    if (getIsAuth()) {
      const u = getUser();
      if (u) { setUserState(u); setIsAuthenticated(true); }
    }
    setLoading(false);
  }, []);

  // Login — calls real API
  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    if (data?.status === 1 && data?.userDetails) {
      const u = data.userDetails;
      setUser(u);
      setIsAuth(true);
      setUserState(u);
      setIsAuthenticated(true);
      return u;
    }
    throw new Error(data?.message || "Invalid credentials");
  };

  // Logout
  const logout = () => {
    clearAuth();
    setUserState(null);
    setIsAuthenticated(false);
  };

  // Handy slug getter
  const userSlug = user?.user_slug || user?.slug || null;

  if (loading) return null;

  return (
    <AuthContext.Provider value={{ user, userSlug, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
export default AuthContext;
